import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import Spinner from "../../../../Component/Spinner";
import { AuthContext } from "../../../../contexts/AuthProvider";

const BookingModal = ({ data }) => {
  const { user, loading } = useContext(AuthContext);
  const { model, sellingPrice, img } = data;
  const { close, setClose } = useState(false);

  if (loading) {
    return <Spinner></Spinner>;
  }

  const handleBooking = (event) => {
    event.preventDefault();
    const form = event.target;
    const model = form.model.value;
    const price = form.price.value;
    const name = form.name.value;
    const email = form.email.value;
    const phone = form.phone.value;
    const location = form.location.value;

    const bookingInfo = {
      model,
      price,
      name,
      email,
      phone,
      location,
      img,
    };

    fetch("https://bike-resell-server-hasanalibd.vercel.app/bookings", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(bookingInfo),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.acknowledged) {
          toast.success("successfully booked");
          event.target.reset();
          setClose(true);
        }
      });

    console.log(bookingInfo);
  };

  return (
    <div>
      <input type="checkbox" id="booking-modal" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box relative">
          <label
            htmlFor="booking-modal"
            className="btn btn-sm btn-circle absolute right-2 top-2"
          >
            ✕
          </label>
          <h3 className="text-xl font-bold mb-5">Booking Information</h3>

          <form onSubmit={handleBooking} className="grid grid-cols-1 gap-3">
            <input
              type="text"
              name="model"
              placeholder="Type here"
              defaultValue={model}
              disabled
              className="input input-bordered w-full text-lg font-semibold"
            />

            <input
              name="price"
              type="number"
              placeholder="Price"
              defaultValue={sellingPrice}
              disabled
              className="input input-bordered w-full font-semibold"
              required
            />

            <input
              name="name"
              type="text"
              placeholder="Your Name"
              value={user?.displayName ? user?.displayName : `Not Found`}
              disabled
              className="input input-bordered w-full"
              required
            />

            <input
              name="email"
              type="email"
              value={user?.email}
              disabled
              placeholder="Email Address"
              className="input input-bordered w-full"
              required
            />

            <input
              name="phone"
              type="number"
              placeholder="Phone Number"
              className="input input-bordered w-full"
              required
            />

            <input
              name="location"
              type="text"
              placeholder="Meet Location"
              className="input input-bordered w-full"
              required
            />

            {/* <button className='btn btn-accent w-full' disabled={close}>submit</button> */}
            <input
              className="btn btn-accent w-full"
              disabled={close}
              type="submit"
              value="Submit"
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default BookingModal;
